"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Upload = function Upload(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/upload-upload" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-upload" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18,20 L18,15.5 C18,15.2238576 18.2238576,15 18.5,15 L19.5,15 C19.7761424,15 20,15.2238576 20,15.5 L20,20.5 L20,21.5 C20,21.7761424 19.7761424,22 19.5,22 L4.5,22 C4.22385763,22 4,21.7761424 4,21.5 L4,20.5 L4,15.5 C4,15.2238576 4.22385763,15 4.5,15 L5.5,15 C5.77614237,15 6,15.2238576 6,15.5 L6,20 L18,20 Z M14.5,9 L18.5074145,9 C18.7835569,9 19.0074145,9.22385763 19.0074145,9.5 C19.0074145,9.63968935 18.9489787,9.77300947 18.8462581,9.86767515 L12.3388453,15.8648037 C12.1473998,16.0412369 11.8526036,16.0412369 11.6611581,15.8648037 L5.15374535,9.86767515 C4.95068397,9.680537 4.93777564,9.36421778 5.1249138,9.1611564 C5.21957948,9.0584358 5.35289959,9 5.49258895,9 L9.5,9 L9.5,2.5 C9.5,2.22385763 9.72385763,2 10,2 L14,2 C14.2761424,2 14.5,2.22385763 14.5,2.5 L14.5,9 Z",
    fill: "inherit",
    id: "path-1-upload" + unique,
    transform: "translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "
  }))));
};

Upload.propTypes = propTypes;
var _default = Upload;
exports["default"] = _default;